module.exports = __webpack_public_path__ + "e4ab7bd057c6d49f21b3460a1bf914a9.svg";